import React, {useEffect, useState} from 'react';

import SelectSmtpProvider from "./SelectSmtpProvider";
import {useFromEmailAddress, useFromEmailSender} from "../../../hooks/use-workspace-config";
import {Integration} from "../../../models";
import {defaultSmtpIntegration} from "./constants";

interface ISelectFromProps {
  integrations: Integration[];
  integration_id: string;
  smtpFromEmail: string;
  onChange: (value: any) => void;
  readOnly: boolean | undefined
}

const SelectFromEmail = ({
  integrations,
  integration_id,
  smtpFromEmail,
  onChange,
  readOnly,
}: ISelectFromProps) => {
  const [filteredEmails, setFilteredEmails] = useState([]);
  const [selectedFromEmail, setSelectedFromEmail] = useState(smtpFromEmail || defaultSmtpIntegration?.config_json?.email_addresses[0].value);

  useEffect(() => {
    setFilteredEmails(filterEmails(integration_id));
  }, [integrations, integration_id]);

  useEffect(() => {
    setSelectedFromEmail(smtpFromEmail);
  }, [smtpFromEmail]);

  const fromEmailAddress = useFromEmailAddress();
  const fromEmailSender = useFromEmailSender();

  // update default smtpIntegration with fromEmailAddress and fromEmailSender from custom email configuration
  if (fromEmailAddress && fromEmailSender && integrations.length === 1 && integrations[0].uid == 'default') {
    if (integrations[0] && integrations[0].config_json) {
      integrations[0].config_json.email_addresses[0].name = fromEmailSender;
      integrations[0].config_json.email_addresses[0].value = fromEmailAddress;
    }
  }

  const filterEmails = (integrationUid: string) => {
    const selectedIntegration = integrations.find((smtp: Integration) => smtp.uid === integrationUid);

    if (selectedIntegration) {
      return selectedIntegration?.config_json?.email_addresses.map((email: any) => ({
        integrationUid: selectedIntegration.uid,
        label: `${email.name} <${email.value}>`,
        value: email.value
      }));
    }
    return [];
  };

  return (
    <>
      <SelectSmtpProvider
        emails={filteredEmails}
        selected={selectedFromEmail}
        onChange={onChange}
        disabled={readOnly}
      />
    </>
  );
}

export default SelectFromEmail;
